import { put, takeEvery, select } from 'redux-saga/effects'

import { ERROR_MODAL_OPEN } from '@redux/actions/types'

import { USER_ERROR_DEFAULT } from '@assets/i18n/strings'

import * as Sentry from '@sentry/browser'

import i18n from 'i18n-js'

const getAuth = state => ({
  hash: state.auth.hash
})

/**
 * Reports the error to Sentry and opens an error modal with a localized message.
 * @param action
 */
function * onError(action) {
  const { status } = action.error.response
  const { error_code: errorCode } = action.error.response.data
  const { type } = action

  const { hash } = yield select(getAuth)

  Sentry.captureException(action.error, (scope) => {
    scope.setExtra('access_code', hash)
  })

  yield put({
    type: ERROR_MODAL_OPEN,
    payload: {
      message: i18n.t(`USER_ERROR_${errorCode}`, { defaultValue: i18n.t(USER_ERROR_DEFAULT) }),
      statusCode: status,
      actionType: type
    }
  })
}

/**
 * Registers a watcher for actions containing API error response data.
 */
function * watchError() {
  yield takeEvery(action => action.error?.response?.data, onError)
}

export default watchError
